import humanize from 'helpers/humanize';

angular.module('gym.components').directive('reportFilter', function() {
  return {
    restrict: 'AE',
    template: require('templates/components/reports/report_filter.html.slim'),
    replace: true,
    scope: {
      report: '=',
      reports: '=',
      aggregate: '=',
      index: '=',
      editable: '=',
      onEdit: '&'
    },
    controller: ["$scope", "$filter", "Months", function($scope, $filter, Months) {
      var filter, ref;
      $scope.filter = filter = $scope.aggregate || ((ref = $scope.report) != null ? ref.report_filters_attributes[$scope.index] : void 0);
      $scope.getTooltip = function(filter) {
        var columnLabel, columnSection, ref1, section, selectedReport, value;
        if (!$scope.report) {
          return;
        }
        if ((ref1 = filter.operator) === 'IN REPORT' || ref1 === 'NOT IN REPORT') {
          selectedReport = _.find($scope.reports, function(item) {
            return item.id === +filter.user_value;
          });
          if (selectedReport) {
            return `Contact > ${filter.operator_label} ${selectedReport.name}`;
          } else {
            return `Contact > ${filter.operator_label.replace(' report', '')} [report deleted]`;
          }
        }
        columnLabel = filter.database_value_label;
        section = _.findKey($scope.report.report_columns_options, function(columns) {
          return _.find(columns, function(column) {
            return column.unique_id === filter.database_value;
          });
        });
        value = filter.relative_date ? humanize(`${filter.number} ${filter.period} ${filter.multiplier}`) : filter.user_value;
        columnSection = $scope.report.column_section_name_map[section];
        return `${columnSection || humanize(section)} > ${columnLabel} ${filter.operator_label} ${value}`;
      };
      $scope.tooltip = $scope.getTooltip($scope.filter);
      if ($scope.filter.report_sub_filters_attributes) {
        $scope.subFilterTooltips = $scope.filter.report_sub_filters_attributes.map($scope.getTooltip);
      }
      $scope.deleteFilter = function() {
        if (filter.id) {
          return filter._destroy = 1;
        } else {
          return $scope.report.report_filters_attributes.splice($scope.index, 1);
        }
      };
      return $scope.joinFilterLabel = function() {
        if (filter.join_filters_with === 'join_filters_with_or') {
          return 'OR';
        } else {
          return 'AND';
        }
      };
    }]
  };
});
